import Plugins from './pluginsTypes';

export default {
	...Plugins,
};



// WEBPACK FOOTER //
// ./src/constants/plugins/index.js